import classNames from "classnames";
import React from "react";

interface Props {
  sizes: {
    value: string;
  }[];
  selectedSize: string;
  handleSizeChange: any;
  isComplete?: boolean;
}

const CartItemSize = ({ sizes, selectedSize, handleSizeChange, isComplete }: Props) => {
  return (
    <div className="cart-item-sizes">
      {/* {!isComplete && <span className="cart-item-sizes-title">Choose Size:</span>} */}
      <span className="cart-item-sizes-subtitle">Size: {selectedSize.toUpperCase()}</span>
      <div className="cart-item-sizes-buttons">
        {!isComplete &&
          sizes?.map((size) => (
            <button
              key={size.value}
              type="button"
              className={classNames("cart-item-sizes-buttons-btn", {
                active: size.value === selectedSize,
              })}
              onClick={() => handleSizeChange(size.value)}
            >
              {size.value}
            </button>
          ))}
      </div>
    </div>
  );
};

export default CartItemSize;
